(function(){
  var LM = window.LM || {}, T = LM.t || {};
  var tr = function(s, o){ s = String(s || ''); if (o) { for (var k in o) { s = s.split('%' + k + '%').join(o[k]); } } return s; };
  var URL_ADD = (LM.add || '/cart/add') + '.js', URL_CHANGE = (LM.change || '/cart/change') + '.js', URL_CART = (LM.cart || '/cart') + '.js', URL_CHECKOUT = (LM.root || '/') + 'checkout';
  var money = LM.money || function(c){ return Math.round(c/100) + ' kr'; };
  var esc = function(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var note = document.getElementById('note'), noteTimer;
  function say(msg){
    if(!note) return;
    note.textContent = msg; note.classList.add('show');
    clearTimeout(noteTimer); noteTimer = setTimeout(function(){ note.classList.remove('show'); }, 2300);
  }

  /* ---- meny ---- */
  var menuBtn = document.getElementById('menu-btn'), drawer = document.getElementById('rooms-drawer');
  function closeDrawer(){ if (drawer) { drawer.hidden = true; menuBtn.setAttribute('aria-expanded','false'); } }
  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', function(){
      var open = drawer.hidden; drawer.hidden = !open;
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !drawer.hidden) { closeDrawer(); menuBtn.focus(); } });
  }

  /* ---- masthode-hoyde ---- */
  var mast = document.querySelector('header.mast');
  function syncMast(){ if (mast) document.documentElement.style.setProperty('--mast-h', Math.round(mast.offsetHeight) + 'px'); }
  syncMast(); window.addEventListener('resize', syncMast);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncMast);

  /* ---- til toppen ---- */
  var up = document.getElementById('up');
  if (up) {
    window.addEventListener('scroll', function(){ up.classList.toggle('show', window.scrollY > 800); }, { passive:true });
    up.addEventListener('click', function(){
      window.scrollTo({ top:0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    });
  }

  /* ---- kurv ---- */
  var bBtn = document.getElementById('basket-btn'), bPanel = document.getElementById('basket'),
      bN = document.getElementById('basket-n'), bList = document.getElementById('basket-list'),
      bEmpty = document.getElementById('basket-empty'), bSum = document.getElementById('basket-sum');

  function paint(cart){
    if (!bN) return;
    bN.textContent = cart.item_count;
    bSum.textContent = money(cart.total_price);
    bBtn.classList.toggle('filled', cart.item_count > 0);
    bEmpty.hidden = cart.item_count > 0;
    bList.innerHTML = '';
    cart.items.forEach(function(item){
      var li = document.createElement('li');
      var name = document.createElement('span'); name.className = 'bl-name';
      var title = item.product_title + (item.variant_title ? ', ' + item.variant_title : '');
      name.textContent = (item.quantity > 1 ? item.quantity + ' × ' : '') + title;
      var sumEl = document.createElement('span'); sumEl.className = 'bl-sum num'; sumEl.textContent = money(item.final_line_price);
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'bl-rm'; rm.setAttribute('aria-label', tr(T.remove || 'Fjern %title%', { title: title })); rm.textContent = '×';
      rm.addEventListener('click', function(){
        fetch(URL_CHANGE, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id:item.key, quantity:0 }) })
          .then(function(r){ return r.json(); }).then(paint);
      });
      li.append(name, sumEl, rm); bList.appendChild(li);
    });
  }
  function refresh(){ return fetch(URL_CART).then(function(r){ return r.json(); }).then(paint).catch(function(){}); }
  function openBasket(on){ if (!bPanel) return; bPanel.hidden = !on; bBtn.setAttribute('aria-expanded', on ? 'true' : 'false'); }
  if (bBtn) {
    bBtn.addEventListener('click', function(e){ e.stopPropagation(); openBasket(bPanel.hidden); });
    bPanel.addEventListener('click', function(e){ e.stopPropagation(); });
    document.addEventListener('click', function(){ openBasket(false); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') openBasket(false); });
    document.getElementById('pay-btn').addEventListener('click', function(){
      if (bN.textContent === '0') { say(T.empty || 'Kurven er tom'); return; }
      window.location.href = URL_CHECKOUT;
    });
    refresh();
  }

  /* ---- headeren glir bort ved scrolling ned, og kommer tilbake ved scrolling opp (mobil og nettbrett) ---- */
  var mqMenu = window.matchMedia('(max-width:1080px)');
  var root = document.documentElement, lastY = window.scrollY, ticking = false;
  function setHidden(on){ root.classList.toggle('mast-hidden', on); }
  function onScroll(){
    var y = window.scrollY;
    var sp = document.getElementById('search-panel');
    var busy = (bPanel && !bPanel.hidden) || (drawer && !drawer.hidden) || (sp && !sp.hidden);
    if (!mast || !mqMenu.matches || busy || y < 480) { setHidden(false); lastY = y; return; }
    if (y > lastY + 8) { setHidden(true); lastY = y; }
    else if (y < lastY - 8) { setHidden(false); lastY = y; }
  }
  window.addEventListener('scroll', function(){
    if (ticking) return; ticking = true;
    requestAnimationFrame(function(){ onScroll(); ticking = false; });
  }, { passive:true });
  if (mqMenu.addEventListener) mqMenu.addEventListener('change', function(){ setHidden(false); });

  /* ---- sok med forslag mens du skriver ---- */
  var sForm = document.getElementById('mast-search');
  if (sForm) {
    var sInput = sForm.querySelector('input[type="search"]'), sPanel = document.getElementById('search-panel'),
        sLive = sPanel.querySelector('.sp-live'), sStatus = document.getElementById('sp-status'),
        sUrl = (sForm.getAttribute('data-suggest') || '/search/suggest').replace(/\/$/, ''), sTimer = null, sCtrl = null;
    var openPanel = function(on){
      sPanel.hidden = !on;
      if (on) { setHidden(false); openBasket(false); closeDrawer(); }
    };
    var clearPanel = function(){
      if (sCtrl) sCtrl.abort();
      sLive.innerHTML = ''; if (sStatus) sStatus.textContent = '';
      openPanel(false);
    };
    var suggest = function(q){
      if (sCtrl) sCtrl.abort();
      sCtrl = ('AbortController' in window) ? new AbortController() : null;
      var params = new URLSearchParams();
      params.append('q', q);
      params.append('section_id', 'lm-predictive');
      params.append('resources[type]', 'product,page');
      params.append('resources[limit]', '6');
      params.append('resources[limit_scope]', 'each');
      params.append('resources[options][unavailable_products]', 'last');
      params.append('resources[options][fields]', 'title,product_type,tag,variants.title,body');
      fetch(sUrl + '?' + params.toString(), sCtrl ? { signal: sCtrl.signal } : {})
        .then(function(r){ if (!r.ok) throw new Error('search ' + r.status); return r.text(); })
        .then(function(html){
          if (q !== sInput.value.trim() || document.activeElement !== sInput) return;
          var res = new DOMParser().parseFromString(html, 'text/html').querySelector('.sp-results');
          if (!res) return;
          sLive.innerHTML = res.innerHTML;
          openPanel(true);
          var n = parseInt(res.getAttribute('data-count') || '0', 10);
          if (sStatus) sStatus.textContent = n ? n + ' ' + (n === 1 ? (T.foundOne || 'vare funnet') : (T.foundOther || 'varer funnet')) : (T.noHits || 'Ingen treff');
        })
        .catch(function(err){ if (err && err.name === 'AbortError') return; });
    };
    sInput.addEventListener('focus', function(){ var q = sInput.value.trim(); if (q.length >= 2) suggest(q); });
    sInput.addEventListener('input', function(){
      var q = sInput.value.trim();
      clearTimeout(sTimer);
      if (q.length < 2) { clearPanel(); return; }
      sTimer = setTimeout(function(){ suggest(q); }, 180);
    });
    sPanel.addEventListener('click', function(e){ if (e.target.closest('a')) { openPanel(false); sInput.blur(); } });
    document.addEventListener('click', function(e){ if (!sForm.contains(e.target)) openPanel(false); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !sPanel.hidden) { openPanel(false); sInput.blur(); } });
    if (bBtn) bBtn.addEventListener('click', function(){ openPanel(false); });
    if (menuBtn) menuBtn.addEventListener('click', function(){ openPanel(false); });
    sForm.addEventListener('submit', function(e){ if (!sInput.value.trim()) { e.preventDefault(); sInput.focus(); } });
  }

  /* ---- legg i kurv ---- */
  document.addEventListener('click', function(e){
    var buy = e.target.closest('.buy');
    if (!buy) return;
    var card = buy.closest('.item');
    var pick = card && card.querySelector('.variant-pick');
    var id = pick ? pick.value : buy.getAttribute('data-variant');
    buy.disabled = true;
    fetch(URL_ADD, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[{ id: parseInt(id,10), quantity:1 }] }) })
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(){ say(tr(T.added || '%name% lagt i kurven', { name: buy.getAttribute('data-name') })); return refresh(); })
      .catch(function(){ say(T.addFailed || 'Kunne ikke legge i kurven'); })
      .then(function(){ buy.disabled = false; });
  });

  document.addEventListener('change', function(e){
    if (!e.target.classList.contains('variant-pick')) return;
    var opt = e.target.options[e.target.selectedIndex];
    var price = e.target.closest('.item').querySelector('.item-price');
    if (price && opt) price.textContent = opt.getAttribute('data-price');
  });

  /* ---- innstillinger for informasjonskapsler ---- */
  document.addEventListener('click', function(e){
    var c = e.target.closest('[data-cookie-prefs]');
    if (!c) return;
    e.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
    else say(T.cookies || 'Innstillinger for informasjonskapsler er ikke tilgjengelige ennå');
  });

  /* ---- godt aa starte med ---- */
  var dataEl = document.getElementById('lm-goods');
  var GOODS = []; try { GOODS = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch(e){}
  var nicheEls = document.querySelectorAll('#niches .niche');
  if (nicheEls.length && GOODS.length) {
    var pos = Array.prototype.map.call(nicheEls, function(el, i){ return Math.floor(i * GOODS.length / nicheEls.length); });
    var frameHTML = function(g){
      if (g.img) return '<img src="' + esc(g.img) + '" alt="' + esc(g.alt) + '" loading="lazy">';
      return '<div class="frame-empty"><span class="mono">' + esc(g.title.charAt(0)) + '</span><span class="label">' + esc(g.type) + '</span></div>';
    };
    var fill = function(el, g){
      el.querySelector('.niche-frame').innerHTML = frameHTML(g);
      var h3 = el.querySelector('h3'); h3.innerHTML = '<a></a>'; h3.firstChild.textContent = g.title; h3.firstChild.href = g.url;
      el.querySelector('p').textContent = g.room + ' · ' + g.price;
      var a = el.querySelector('.label-link'); a.textContent = tr(T.seeAllIn || 'Se alle i %room%', { room: g.room }); a.setAttribute('href', '#' + g.roomHandle);
    };
    var render = function(el, idx){
      var g = GOODS[idx % GOODS.length];
      if (reduceMotion.matches) { fill(el, g); return; }
      el.style.opacity = '0';
      setTimeout(function(){ fill(el, g); el.style.opacity = '1'; }, 220);
    };
    var step = function(dir){
      pos = pos.map(function(p){ return (p + dir + GOODS.length) % GOODS.length; });
      Array.prototype.forEach.call(nicheEls, function(el, i){ render(el, pos[i]); });
    };
    var prev = document.getElementById('niche-prev'), next = document.getElementById('niche-next');
    if (prev) prev.addEventListener('click', function(){ step(-1); });
    if (next) next.addEventListener('click', function(){ step(1); });
  }

  /* ---- pakker: legg alle varene i kurven med ett klikk ---- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.pk-add');
    if (!btn) return;
    var ids = (btn.getAttribute('data-variants') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    btn.disabled = true;
    var items = ids.map(function(id){ return { id: parseInt(id, 10), quantity: 1 }; });
    fetch(URL_ADD, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: items }) })
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(){ say(tr(T.added || '%name% lagt i kurven', { name: btn.getAttribute('data-name') })); return refresh(); })
      .catch(function(){ say(T.packFailed || 'Kunne ikke legge pakken i kurven'); })
      .then(function(){ btn.disabled = false; });
  });

  /* ---- pakker: bla med pilene, sveip paa mobil ---- */
  document.querySelectorAll('[data-pk]').forEach(function(track){
    var box = track.closest('.pk'); if (!box) return;
    var prev = box.querySelector('.pk-prev'), next = box.querySelector('.pk-next');
    var stepW = function(){ var c = track.querySelector('.pk-card'); if (!c) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap) || 0; return c.getBoundingClientRect().width + gap; };
    var sync = function(){
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    var go = function(dir){ track.scrollBy({ left: dir * stepW(), behavior: reduceMotion.matches ? 'auto' : 'smooth' }); };
    if (prev) prev.addEventListener('click', function(){ go(-1); });
    if (next) next.addEventListener('click', function(){ go(1); });
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(sync); }, { passive:true });
    track.addEventListener('keydown', function(e){ if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); } });
    window.addEventListener('resize', sync); sync();
  });

  /* ---- filtre, med tydelig beskjed naar listen er filtrert ---- */
  var filters = document.getElementById('filters'), showing = document.getElementById('showing'), shelves = document.getElementById('shelves');
  if (filters && shelves && showing) {
    var rooms = shelves.querySelectorAll('.room');
    var total = shelves.getAttribute('data-total') || shelves.querySelectorAll('.item').length;
    showing.setAttribute('aria-live', 'polite');
    filters.addEventListener('click', function(e){
      var btn = e.target.closest('.filter-btn'); if (!btn) return;
      var pick = btn.getAttribute('data-room');
      filters.querySelectorAll('.filter-btn').forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var shown = 0;
      rooms.forEach(function(r){
        var on = pick === 'all' || r.getAttribute('data-room') === pick;
        r.hidden = !on; if (on) shown += r.querySelectorAll('.item').length;
      });
      showing.textContent = '';
      showing.classList.toggle('is-filtered', pick !== 'all');
      if (pick === 'all') { showing.textContent = tr(T.showingAll || 'Viser alle %total% varer', { total: total }); return; }
      var label = btn.firstChild.textContent.trim();
      showing.appendChild(document.createTextNode(tr(T.showingIn || 'Viser %n% %unit% i %room%', { n: shown, unit: shown === 1 ? (T.one || 'vare') : (T.other || 'varer'), room: label })));
      var sep = document.createElement('span'); sep.className = 'show-sep'; sep.setAttribute('aria-hidden', 'true'); sep.textContent = '·';
      var reset = document.createElement('button'); reset.type = 'button'; reset.className = 'show-all'; reset.textContent = tr(T.showAll || 'Vis alle %total%', { total: total });
      reset.addEventListener('click', function(){
        var all = filters.querySelector('.filter-btn[data-room="all"]');
        if (all) { all.click(); all.focus(); }
      });
      showing.append(sep, reset);
    });
  }
})();
